import { onHomepage } from '../dom';

export const isHomepageRefresh = (location, edition_data, isMobile, homepageOverride = false) =>
  isMobile &&
  (onHomepage(location, edition_data) || homepageOverride);
